import { useEffect, useState } from "react";
import GetUserType from "../model/GetUserType";
import UsersMainLayoutUser from "./UsersMainLayoutUser";
import DeveloperMainLayout from "./DeveloperMainLayout";
import AdminMainLayout from "./AdminMainLayout";
import { Backdrop, CircularProgress } from "@mui/material";
import { useToast } from "../../basecomp/components/provider/ToastProvider";
import PexTeamMainLayout from "./PexTeamMainLayout";
// import { useToast } from "../../basecomp/components/provider/ToastProvider";


function MainLayout() {
  const [usertype, setUserType] = useState("");
  const [loading, setLoading] = useState(true);
  const { handleToastOpen } = useToast()
  

  useEffect(() => {
    const getuserid = async () => {
      try{
      const typeOfUser = await GetUserType();
      setUserType(typeOfUser.data.user_role);
      }
      catch(error){
        handleToastOpen("error","Somthing went wrong in getting user type")
      }
      finally{

        setLoading(false);
      }
    };
    getuserid();
  }, []);

  if (loading) return (
    <>
    <Backdrop open={loading}>
      <CircularProgress></CircularProgress>
    </Backdrop>
    </>
  );

  if (usertype === "Conas Developer") {
    return <DeveloperMainLayout />;
  }
  else if (usertype === "It Admin") {
    return <AdminMainLayout />;
  }
  else if(usertype ==="Pex Team"){
    return <PexTeamMainLayout/>
  }
  else{
    return <UsersMainLayoutUser />;
  }



}

export default MainLayout;
